import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import GeoContext from 'contexts/geoContext'
import { capitalise } from 'lib/string/stringUtils'

interface Options {
  titlecase?: boolean
}

function useLocalizedInsuranceProductName({ titlecase = false }: Options = {}): string {
  const { insuranceProductName } = useContext(GeoContext)
  const intl = useIntl()

  return useMemo(() => {
    const localizedProductName = insuranceProductName.trim().toLocaleLowerCase('en-AU') === 'protection' ?
        intl.formatMessage({
          id: 'GBtXS9J3BeH18SMUV27I',
          defaultMessage: 'protection',
          description: 'Fallback insurance product noun inserted into the add travel CTA when no specific travel protection product name is available',
        }) :
      insuranceProductName

    return titlecase ? capitalise(localizedProductName) : localizedProductName
  }, [insuranceProductName, intl, titlecase])
}

export default useLocalizedInsuranceProductName
